<template>
  <!-- eslint-disable-next-line @intlify/vue-i18n/no-missing-keys -->
  <SmDialog v-model:visibility="visible" :title="dialogTitle">
    <el-descriptions border :column="1">
      <el-descriptions-item width="5rem" label-class-name="description-label">
        <template #label>
          <span class="cell-item">{{ t('general.action') }} </span>
        </template>
        {{ activityMessage }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="description-label">
        <template #label>
          <span class="cell-item"> {{ t('general.timestamp') }} </span>
        </template>
        {{ timestamp }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="description-label">
        <template #label>
          <span class="cell-item"> {{ t('general.user') }} </span>
        </template>
        {{ accEmail }}
      </el-descriptions-item>
    </el-descriptions>
  </SmDialog>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import {
    Account,
    ActivityBaseModel,
    PriceInformation,
    SoftwareLicense,
    UserProfilePublic,
  } from '@/client'
  import { getI18nArgs } from '@/utils/activity'
  import { displayDate } from '@/utils/formatter/date'

  const { t } = useI18n()
  const props = defineProps<{
    activity: ActivityBaseModel
    userProfiles: Record<string, UserProfilePublic>
    visible: boolean
    allUser: Account[]
    allSoftwareLicenses: SoftwareLicense[]
    allContracts: PriceInformation[]
  }>()
  const emit = defineEmits(['update:visible'])

  const visible = computed({
    get: () => props.visible,
    set: (v) => {
      emit('update:visible', v)
    },
  })

  // eslint-disable-next-line @intlify/vue-i18n/no-missing-keys
  const dialogTitle = t('activity.activityInformation')

  const timestamp = computed(() =>
    displayDate(new Date(props.activity.created), {
      dateStyle: 'short',
      timeStyle: 'medium',
    })
  )

  const accEmail = computed(() => {
    return props.userProfiles[props.activity.identity_id]?.email
  })

  const activityMessage: Ref<string | null> = ref(null)

  async function fetchActivityMessage() {
    const args = await getI18nArgs(
      props.activity,
      props.allUser,
      props.allSoftwareLicenses,
      props.allContracts,
      props.userProfiles[props.activity.identity_id]
    )

    activityMessage.value = t(`activity.${props.activity.action}`, args)
  }

  watch(() => props.activity, fetchActivityMessage)
</script>
